// Resources
import React, { Component } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import App from "./App";
import Login from "./Login";
import Company from "./Company";
import Form from "./Form";
import FourOhFour from "./404";
import Image from "./Image";
import Legacy from "./Legacy";
import Opportunity from "./Opportunity";
import Wiki from "./Wiki";
import Admin from "./Admin";
import Aop from "./Aop";
import Cop from "./Cop";
import ErrorBoundary from "./components/body/ErrorBoundary";

// Auth
import AuthHelperMethods from "./components/auth/AuthHelperMethods";

export default class Root extends Component {
	Auth = new AuthHelperMethods();

	constructor(props) {
		super(props);
		this.state = {
			domain: "",
			googleClientId: ""
		};
	}

	componentDidMount() {
		// Fetch login data
		this.Auth.loginInit()
			.then((res) => {
				console.log("[ Login - componentDidMount ] res:", res);
				if (res.domain && res.google_client_id) {
					this.setState({
						domain: res.domain,
						googleClientId: res.google_client_id
					});
				}
			})
			.catch((err) => {
				console.log("[ Login - componentDidMount ] err:", err);
			});
	}

	render() {
		return (
			<Router>
				<ErrorBoundary>
					{this.state.googleClientId && (
						<GoogleOAuthProvider clientId={this.state.googleClientId}>
							<Routes>
								<Route path="/" element={<App />} />
								<Route exact path="/404" element={<FourOhFour />} />
								<Route exact path="/image" element={<Image />} />
								<Route exact path="/login" element={<Login />} />
								<Route exact path="/company" element={<Company />} />
								<Route exact path="/form" element={<Form />} />
								<Route exact path="/legacy" element={<Legacy />} />
								<Route exact path="/opportunity" element={<Opportunity />} />
								<Route path="/wiki/*" element={<Wiki />} />
								<Route path="/admin" element={<Admin />} />
								<Route path="/aop" element={<Aop />} />
								<Route path="/cop" element={<Cop />} />
								<Route element={<FourOhFour />} />
							</Routes>
						</GoogleOAuthProvider>
					)}
				</ErrorBoundary>
			</Router>
		);
	}
}
